import Vue from "vue";
import VueI18n from "vue-i18n";

import Cookie from "js-cookie";
const qs = require("qs");

Vue.use(VueI18n);

const params = qs.parse(location.search, { ignoreQueryPrefix: true });
let locale = (
  params["language"] ||
  Cookie.get("language") ||
  (navigator.languages
    ? navigator.languages[0]
    : navigator.language || navigator.userLanguage) ||
  process.env.VUE_APP_I18N_LOCALE ||
  "en-US"
).replace("_", "-");

const localeTrans = { el: "el-GR", cs: "cs-CZ", et: "et-EE", sv: "sv-SE" };

if (locale.length == 2) {
  if (localeTrans[locale]) {
    locale = localeTrans[locale];
  } else {
    locale = locale + "-" + locale.toUpperCase();
  }
}

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export default new VueI18n({
  locale: locale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en-US",
  messages: loadLocaleMessages(),
});
